/*
  [JS Index]
*/

/*
  1. preloader
  2. slick slider
    2.1. slick about slider
    2.2. slick contact slider
    2.3. slick ZOOM/FADE slideshow
  3. owl carousel
    3.1. owl works carousel
    3.2. owl news carousel
  4. skills bar
  5. facts counter
  6. navigation
    6.1. navigation icon
    6.2. navigation panels
    6.3. navigation links
    6.4. navigation hover state
  7. fullPage
  8. YouTube player
  9. toggle news content
  10. swiper slider
  11. magnificPopup
  12. contact form
  13. news position reset
*/

import photos from './photos/*.{jpg,jpeg}';
import './plugins.js';
import Swiper from './js/swiper.js';

$(function() {
    "use strict";
	
    // 1. preloader
    $("#preloader").fadeOut(1000);
    $(".preloader-bg").delay(800).fadeOut(1000);
	
    // 2. slick slider
    // 2.1. slick about slider
    $(".slick-lokasyon").slick({
        arrows: true,
        initialSlide: 0,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<i class='slick-prev icon ion-chevron-left'></i>",
        nextArrow: "<i class='slick-next icon ion-chevron-right'></i>",
        appendArrows: ".slick-nav-custom-about",
        fade: false,
        autoplay: false,
        autoplaySpeed: 4000,
        cssEase: "ease",
        speed: 500
    });
    $(".slick-konaklama").slick({
        arrows: true,
        initialSlide: 0,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<i class='slick-prev icon ion-chevron-left'></i>",
        nextArrow: "<i class='slick-next icon ion-chevron-right'></i>",
        appendArrows: ".slick-nav-custom-about",
        fade: false,
        autoplay: false,
        autoplaySpeed: 4000,
        cssEase: "ease",
        speed: 500
    });
    // 2.2. slick contact slider
    $(".slick-contact").slick({
        arrows: true,
        initialSlide: 0,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<i class='slick-prev icon ion-chevron-left'></i>",
        nextArrow: "<i class='slick-next icon ion-chevron-right'></i>",
        appendArrows: ".slick-nav-custom-contact",
        fade: false,
        autoplay: false,
        autoplaySpeed: 4000,
        cssEase: "ease",
        speed: 500
    });
    // 2.3. slick ZOOM/FADE slideshow
    $(".slick-fullscreen-slideshow-zoom-fade").slick({
        arrows: false,
        initialSlide: 0,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: "<i class='slick-prev icon ion-chevron-left'></i>",
        nextArrow: "<i class='slick-next icon ion-chevron-right'></i>",
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
        speed: 1600,
        draggable: true,
        dots: false,
        pauseOnDotsHover: true,
        pauseOnFocus: false,
        pauseOnHover: false
    });
	
    // // 3. owl carousel
    // // 3.1. owl works carousel
    // $("#works-page-img-carousel").owlCarousel({
    //     loop: false,
    //     center: false,
    //     autoplay: false,
    //     autoplaySpeed: 1000,
    //     autoplayTimeout: 5000,
    //     smartSpeed: 450,
    //     nav: false,
    //     nav: true,
    //     navText: ["<i class='ion-chevron-left'></i>", "<i class='ion-chevron-right'></i>"],
    //     navContainer: '.owl-nav-custom-works',
    //     items: 1,
    //     margin: 0
    // });
    // // 3.2. owl news carousel
    // $("#news-page-img-carousel").owlCarousel({
    //     loop: false,
    //     center: false,
    //     autoplay: false,
    //     autoplaySpeed: 1000,
    //     autoplayTimeout: 5000,
    //     smartSpeed: 450,
    //     nav: false,
    //     nav: true,
    //     navText: ["<i class='ion-chevron-left'></i>", "<i class='ion-chevron-right'></i>"],
    //     navContainer: '.owl-nav-custom-news',
    //     items: 1,
    //     margin: 0
    // });
	
    // // 4. skills bar
    // $(".show-skillbar").appear(function() {
    //     $(".skillbar").skillBars({
    //         from: 0,
    //         speed: 4000,
    //         interval: 100,
    //         decimals: 0
    //     });
    // });
	
    // // 5. facts counter
    // $(".facts-counter-number").appear(function() {
    //     var count = $(this);
    //     count.countTo({
    //         from: 0,
    //         to: count.html(),
    //         speed: 1200,
    //         refreshInterval: 60
    //     });
    // });
	
    // 6. navigation
    // 6.1. navigation icon
    // 6.2. navigation panels
    $(".navigation-fire").on("click", function(e) {
        if ($(".panel-from-left, .panel-from-right, .panel-overlay-from-left, .panel-overlay-from-right").hasClass("open")) {
            $(".panel-from-left, .panel-from-right, .panel-overlay-from-left, .panel-overlay-from-right").removeClass("open");
        } else {
            $(".panel-from-left, .panel-from-right, .panel-overlay-from-left, .panel-overlay-from-right").addClass("open");
        }
    });
    // 6.3. navigation links
    $("nav.navigation-menu a").on("click", function(e) {
        $(".panel-from-left, .panel-from-right, .panel-overlay-from-left, .panel-overlay-from-right").removeClass("open");
    });
    // 6.4. navigation hover state
    hoverMenu();
    imgMenu();
    function hoverMenu() {
        $(".menu li a").on("mouseenter", function() {
            var ref = $(this).data("ref"),
                menuImg = $('.menu-img[data-ref="' + ref + '"]');
            $(".menu li a").removeClass("active");
            $(this).addClass("active");
            $(".menu-img").removeClass("active");
            menuImg.addClass("active");
        });
    }
    function imgMenu() {
        $("[data-bg]").each(function() {
            var bg = $(this).data("bg");
            // console.log(bg, photos, photos[bg]?.jpg);
            var fullUrl = photos[bg]?.jpg;
            $(this).css({
                "background-image": 'url(' + fullUrl + ')',
                "background-position": "center center",
                "background-size": "cover"
            });
        });
    }
	
    // 7. fullPage
    $("#fullpage").fullpage({
        anchors: ["home", "lokasyon", "biz", "konaklama", "iletisim"],
        navigation: true,
        navigationPosition: "right",
        navigationTooltips: ["Home", "Lokasyon", "Biz", "Konaklama", "İletişim"],
        responsiveWidth: 995,
        autoScrolling: true,
        scrollBar: false,
        afterResponsive: function(isResponsive) {}
    });
	
    // 8. YouTube player
    // $("#bgndVideo").YTPlayer();
	
    // // 9. toggle news content
    // $(".the-button-details-news").on("click", function() {
    //     $(".logo, .round-menu").addClass("off").removeClass("on");
    //     var divClass = $(this).attr("data-id");
    //     if ($(this).hasClass("open")) {
    //         $(this).removeClass("open");
    //         $("." + divClass).addClass("open");
    //     } else {
    //         $(this).addClass("open");
    //         $("." + divClass).addClass("open");
    //     }
    // });
    // $(".the-button-details-news-closer").on("click", function() {
    //     $(".panel-left, .panel-right").removeClass("open");
    //     $(".logo, .round-menu").removeClass("off").addClass("on");
    // });
	
    // 10. swiper slider
    var swiper = new Swiper(".parallax .swiper-container", {
        autoplay: false,
        loop: false,
        speed: 1600,
        grabCursor: true,
        mousewheel: false,
        keyboard: true,
        simulateTouch: true,
        parallax: true,
        effect: "slide",
        pagination: false,
        scrollbar: false,
        navigation: {
            nextEl: ".slide-next",
            prevEl: ".slide-prev"
        }
    });
	
    // // 11. magnificPopup
    // $(".popup-photo").magnificPopup({
    //     type: "image",
    //     gallery: {
    //         enabled: false,
    //         tPrev: "",
    //         tNext: "",
    //         tCounter: "%curr% / %total%"
    //     },
    //     removalDelay: 100,
    //     mainClass: "mfp-fade",
    //     fixedContentPos: false
    // });
    // $(".popup-photo-gallery").each(function() {
    //     $(this).magnificPopup({
    //         delegate: "a",
    //         type: "image",
    //         gallery: {
    //             enabled: true
    //         },
    //         removalDelay: 100,
    //         mainClass: "mfp-fade",
    //         fixedContentPos: false
    //     });
    // });
	
    // // 12. contact form
    // $("form#form").on("submit", function() {
    //     $("form#form .error").remove();
    //     var s = !1;
    //     if ($(".requiredField").each(function() {
    //             if ("" === jQuery.trim($(this).val())) $(this).prev("label").text(), $(this).parent().append('<span class="error">Lütfen bu alanı doldurunuz</span>'), $(this).addClass(
    //                 "inputError"), s = !0;
    //             else if ($(this).hasClass("email")) {
    //                 var r = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    //                 r.test(jQuery.trim($(this).val())) || ($(this).prev("label").text(), $(this).parent().append('<span class="error">Geçersiz e-posta adresi</span>'), $(this).addClass(
    //                     "inputError"), s = !0);
    //             }
    //         }), !s) {
    //         $("form#form input.submit").fadeOut("normal", function() {
    //             $(this).parent().append("");
    //         });
    //         var r = $(this).serialize();
    //         $.post($(this).attr("action"), r, function() {
    //             $("form#form").slideUp("fast", function() {
    //                 $(this).before('<div class="success">Mesajınız başarıyla gönderildi.</div>');
    //             });
    //         });
    //     }
    //     return !1;
    // });
	
	
});


// // 13. news position reset
// $(".the-button-details-news").on("click", function() {
//     target = $(".news-page-img-wrapper");
//     $("html, body").animate({
//         scrollTop: target.offset().top
//     }, 500);
// });